export default function parseJson(responseText) {
  try {
    return JSON.parse(responseText);
  } catch (e) {
    return responseText;
  }
}
//# sourceMappingURL=parseJson.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/web-sdk/dist/esm/json/parseJson.js
// module id = 225
// module chunks = 0 1